var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":`https://capacita.iusa.com.mx/acceso.valida.php?u=${_vm.userId}`,"target":"_blank"}},[_c('svg-icon',{attrs:{"name":"iusa-capacita","label":_vm.label,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }